export function createObserver(target, callback) {
  const options = {
    root: null,
    threshold: 0.25
  };
  const observer = new IntersectionObserver(callback, options);
  observer.observe(target);
}